import React, { useState } from 'react';
import { FaStar } from 'react-icons/fa';
import './SurveyModal.css';

const QUESTIONS = [
  'How easy was it to find the product you wanted?',
  'How would you rate our pricing?',
  'How was your experience with the payment system?',
  'How intuitive was the site navigation?',
  'Overall, how satisfied are you with our site?',
];

export default function SurveyModal({ onClose }) {
  // answers[index] = rating 1–5
  const [answers, setAnswers] = useState(QUESTIONS.map(() => 0));
  const [comment, setComment] = useState('');

  const handleStarClick = (qIndex, value) => {
    setAnswers((prev) => prev.map((r, i) => (i === qIndex ? value : r)));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Survey results:', { answers, comment });
    // You could POST these to an API here…
    onClose();
  };

  return (
    <div className="survey-overlay">
      <div className="survey-modal">
        <h2>We value your feedback!</h2>
        <form onSubmit={handleSubmit}>
          {QUESTIONS.map((q, i) => (
            <div key={i} className="survey-question">
              <p>{q}</p>
              <div className="star-row">
                {[1, 2, 3, 4, 5].map((n) => (
                  <FaStar
                    key={n}
                    className={answers[i] >= n ? 'star selected' : 'star'}
                    onClick={() => handleStarClick(i, n)}
                  />
                ))}
              </div>
            </div>
          ))}

          <label>
            Comments (optional):
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Tell us more…"
              rows="4"
            />
          </label>

          <div className="survey-actions">
            <button type="button" onClick={onClose}>
              Skip
            </button>
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
}
